export enum PlanChipType {
  EXAM = 'exam',
  HAND_IN = 'hand-in',
  HOMEWORK = 'homework',
  SUBTASK = 'subtask',
  APPOINTMENT = 'appointment',
}

export enum PlanChipFill {
  OUTLINE = 'outline',
  SOLID = 'solid',
}

export enum PlanChipSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}
